import React from "react";
import styles from "./index.module.scss";
import {Title} from "@src/components/ui/Title";

import scenesIcon1 from "@imgs/home/scenes_icon1.png";
import scenesIcon2 from "@imgs/home/scenes_icon2.png";
import scenesIcon3 from "@imgs/home/scenes_icon3.png";

export const Scenes = () => {
  return <div className={styles.scenes}>
    <Title text={'应用场景'} />
    <div className={styles.content}>
      <div className={styles.item}>
        <div className={styles.header}>
          <img src={scenesIcon1}/>
        </div>
        <div className={styles.title}>电子证据</div>
        <div className={styles.desc}>建立一条由电子数据到电子证据的区块链可信数据通道，为司法机构解决电子证据难认定问题</div>
      </div>
      <div className={styles.item} style={{margin: '0 150px'}}>
        <div className={styles.header}>
          <img src={scenesIcon2}/>
        </div>
        <div className={styles.title}>知识产权</div>
        <div className={styles.desc}>为知识产权保护提供科技支撑，促进数字知识产权产业发展，提升数字证据法律效力</div>
      </div>
      <div className={styles.item}>
        <div className={styles.header}>
          <img src={scenesIcon3}/>
        </div>
        <div className={styles.title}>司法协同</div>
        <div className={styles.desc}>增进司法业务协同，赋能国家智慧司法运行支撑体系建设，为建成公正、透明的司法体系提供科技支撑</div>
      </div>
    </div>
  </div>
}
